export type AccessibilityFontSize = 'small' | 'medium' | 'large' | 'x-large'
export type AccessibilityLineSpacing = 'normal' | 'comfortable' | 'wide'

const FONT_SIZE_MAP: Record<AccessibilityFontSize, string> = {
  small: '14px',
  medium: '16px',
  large: '18px',
  'x-large': '20px',
}

export function getBaseFontSize(fontSize: AccessibilityFontSize): string {
  return FONT_SIZE_MAP[fontSize]
}

export function applySharedAccessibilityDomState(
  settings: {
    fontSize: AccessibilityFontSize
    lineSpacing: AccessibilityLineSpacing
    highContrast: boolean
    reduceMotion: boolean
    dyslexiaFont: boolean
    screenReaderOptimized: boolean
  },
  options?: {
    increaseDyslexiaFontSizePercent?: number
  },
): void {
  if (typeof window === 'undefined') return

  const root = document.documentElement

  let baseFontSize = getBaseFontSize(settings.fontSize)
  const dyslexiaIncrease = options?.increaseDyslexiaFontSizePercent ?? 0
  if (settings.dyslexiaFont && dyslexiaIncrease > 0) {
    const sizeValue = parseInt(baseFontSize, 10)
    baseFontSize = `${Math.round(sizeValue * (1 + dyslexiaIncrease / 100))}px`
  }

  root.style.setProperty('--base-font-size', baseFontSize)

  root.classList.toggle('high-contrast', settings.highContrast)
  root.classList.toggle('reduce-motion', settings.reduceMotion)
  root.classList.toggle('dyslexia-font', settings.dyslexiaFont)
  root.classList.toggle('screen-reader-optimized', settings.screenReaderOptimized)

  root.classList.remove('line-spacing-normal', 'line-spacing-comfortable', 'line-spacing-wide')
  root.classList.add(`line-spacing-${settings.lineSpacing}`)
}
